import { DOCUMENT, inject, Injectable, signal } from '@angular/core';
import { EnvironmentService } from '@core/services/environment.service';
import lazySizes from 'lazysizes';
import 'lazysizes/plugins/attrchange/ls.attrchange';

lazySizes.cfg.init = false;

@Injectable({
    providedIn: 'root',
})
export class LazysizesService {
    private document = inject(DOCUMENT);
    private environmentService = inject(EnvironmentService);
    private enabled = signal(true);

    isEnabled = this.enabled.asReadonly();
    constructor() {
        if (this.environmentService.isBrowser()) {
            try {
                this.document.createEvent('Event');
                lazySizes.init();
            } catch (error) {
                if (error instanceof TypeError) {
                    console.warn('Caught lazySizes error, disabling', error);
                    this.enabled.set(false);
                } else {
                    throw error;
                }
            }
        }
    }
}
